import Input from "components/input";
import { IOrgRoleForm, IPermission, PermissionAction } from "interfaces";
import { UseFormResetField } from "react-hook-form";
import { arrayCompare } from "utills/helpers";

interface PermissionProps {
  disabled?: boolean;
  resetField?: UseFormResetField<IOrgRoleForm>;
  data?: IPermission[];
  permissionMaximumData: IPermission[];
  onChange?: (data: IPermission[]) => void;
}

const PERMISSION_ACTIONS_BY_ORDER = [
  PermissionAction.VIEW,
  PermissionAction.EDIT,
  PermissionAction.CREATE,
  PermissionAction.EXPORT,
  PermissionAction.DELETE,
];

// function PermissionSkeleton() {
//   return (
//     <>
//       {[...Array(10).keys()].map((index: number) => (
//         <div
//           className="py-4 sm:px-4 sm:grid sm:grid-cols-6 sm:gap-4 animate-pulse"
//           key={index}
//         >
//           <div className="text-sm sm:col-span-2">
//             <div className="h-3 bg-gray-200 rounded-full w-40" />
//           </div>
//           <div className="grid grid-cols-2 gap-4 mt-6 sm:mt-0 sm:grid-cols-4 sm:col-span-4">
//             <div className="w-fit flex items-center">
//               <div className="h-3 bg-gray-200 rounded-full w-12"></div>
//             </div>
//             <div className="w-fit flex items-center">
//               <div className="h-3 bg-gray-200 rounded-full w-12"></div>
//             </div>
//             <div className="w-fit flex items-center">
//               <div className="h-3 bg-gray-200 rounded-full w-12"></div>
//             </div>
//             <div className="w-fit flex items-center">
//               <div className="h-3 bg-gray-200 rounded-full w-12"></div>
//             </div>
//           </div>
//         </div>
//       ))}
//     </>
//   );
// }

export const Permissions = ({
  disabled = false,
  data = [],
  permissionMaximumData = [],
  onChange,
}: PermissionProps) => {
  const _handleChangeAction = (
    selectedPermission: IPermission,
    action: PermissionAction[],
    isChecked: boolean
  ) => {
    const updatedPermissions = [...data];

    const pIndex = updatedPermissions.findIndex(
      (p) =>
        p.resource === selectedPermission.resource &&
        p.app === selectedPermission.app
    );

    if (pIndex < 0) return;

    if (isChecked) {
      const isCheckedViewAction =
        action.includes(PermissionAction.CREATE) ||
        action.includes(PermissionAction.EDIT) ||
        action.includes(PermissionAction.EXPORT) ||
        action.includes(PermissionAction.DELETE);
      updatedPermissions[pIndex].actions = [
        ...new Set([
          ...updatedPermissions[pIndex].actions,
          ...action,
          ...(isCheckedViewAction ? [PermissionAction.VIEW] : []),
        ]),
      ];
    } else {
      const filterActions = action.includes(PermissionAction.VIEW)
        ? [
            ...new Set([
              ...action,
              ...[
                PermissionAction.CREATE,
                PermissionAction.EDIT,
                PermissionAction.EXPORT,
                PermissionAction.DELETE,
              ],
            ]),
          ]
        : action;
      updatedPermissions[pIndex].actions = updatedPermissions[
        pIndex
      ].actions.filter((actions) => !filterActions.includes(actions));
    }

    onChange?.(updatedPermissions);
  };

  return (
    <div className="bg-transparent divide-y divide-gray-100 sm:bg-magnolia-400 sm:rounded-lg sm:shadow-sm">
      <div className="hidden sm:p-4 sm:grid sm:grid-cols-7 sm:gap-4" hidden>
        <p className="text-base sm:col-span-2 font-semibold">Permission name</p>
        <p className="text-base sm:col-span-5 font-semibold">Action name</p>
      </div>
      {permissionMaximumData.map((permission: IPermission) => {
        const formPermissionValues = data.find(
          (item) =>
            item.resource === permission.resource && item.app === permission.app
        );
        return (
          <div
            className="py-4 sm:px-4 sm:grid sm:grid-cols-7 sm:gap-4"
            key={`${permission.app}:${permission.resource}`}
          >
            <p className="text-sm sm:col-span-2">{permission.name}</p>
            <div className="grid grid-cols-2 gap-x-4 gap-y-6 mt-6 sm:mt-0 sm:grid-cols-4 xl:grid-cols-6 sm:col-span-5">
              <div className="w-fit flex items-center">
                <Input
                  type="checkbox"
                  label="All"
                  id={`${permission.app}:${permission.resource}-all`}
                  checked={
                    arrayCompare(
                      permission.actions,
                      formPermissionValues?.actions ?? []
                    ) ?? false
                  }
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    _handleChangeAction(
                      permission,
                      permission.actions,
                      e.target.checked
                    )
                  }
                  disabled={disabled}
                />
              </div>
              {PERMISSION_ACTIONS_BY_ORDER.map((action) => (
                <div className="w-fit flex items-center" key={action}>
                  {permission.actions.includes(action) ? (
                    <Input
                      type="checkbox"
                      label={action}
                      id={`${permission.app}:${permission.resource}-${action}`}
                      checked={
                        formPermissionValues?.actions.includes(action) ?? false
                      }
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        _handleChangeAction(
                          permission,
                          [action],
                          e.target.checked
                        )
                      }
                      disabled={disabled}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
